import {Button, ButtonGroup} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {useState} from 'react';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface ConfirmGeneratedDescriptionsDialogProps extends TestIdProps {
  // Saves the whole advertisement form (PATCH + confirm-generated-descriptions) and decides
  // whether to open the platform detail. Owns dialog close and navigation.
  onConfirm: () => Promise<void>;
  // Closes the dialog without saving or navigating; the regenerated batch is kept.
  onDecline: () => void;
}

export function ConfirmGeneratedDescriptionsDialog(props: ConfirmGeneratedDescriptionsDialogProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    await props.onConfirm();
  };

  return (
    <VStack spacing={4}>
      <Text>{i18n.t('page.advertisement.labels.confirmGeneratedDescriptionsText')}</Text>
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          onClick={props.onDecline}
          isDisabled={isSubmitting}
          title={i18n.t('general.actions.cancel')}
          data-testid={suffixTestId('decline', props)}
        />
        <Button
          variant="primary"
          onClick={handleConfirm}
          isLoading={isSubmitting}
          title={i18n.t('general.actions.saveAndContinue')}
          data-testid={suffixTestId('confirm', props)}
        />
      </ButtonGroup>
    </VStack>
  );
}
